import React, { useEffect } from 'react'
import { useUser } from 'reactfire'
import { LinearProgress } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

interface IProps {}

const Authentication: React.FC<IProps> = (props) => {
  const user = useUser()

  // const verifyAuthenticationWithCustomToken = useCallback(async () => {
  //   try {
  //     const result = await getCustomToken()

  //     if (result && result.customToken) {
  //       await auth.signInWithCustomToken(result.customToken)
  //       return
  //     }
  //   } catch (e) {}

  //   localStorage.setItem('old_direction', window.location.href)
  //   window.location.href = '/login'
  // }, [auth])

  const history = useHistory()

  useEffect(() => {
    if (!user) {
      // verifyAuthenticationWithCustomToken()
      //   .then()
      //   .catch((e) => {
      //     console.error(e)
      //   })
      history.push('/login')
    }
  }, [history, user])

  if (!user) {
    return <LinearProgress />
  }

  return <>{props.children}</>
}

export default Authentication
